enum DkBicValue {
  DABADKKK = 'DABADKKK',
  KRONDK22 = 'KRONDK22',
}

export default DkBicValue;
